<template>
  <div class="">
    <custom-dialog :title="$t('components_device_detail_date_datePicker.xzjlsjfw')" :visible="visible" :appendToBody="true" v-on="$listeners" width="400px">
      <div class="dialog-body device-date-event-datePicker">
        <div class="tip">
          <i class="icon icon-tishi"></i>
          <span>{{ $t('components_device_detail_date_datePicker.zzcjlsjqjfwz30') }}{{ $t('components_device_detail_date_datePicker.tndsjdc') }}</span>
        </div>
        <el-form :model="form" :inline="true" ref="form" label-width="120px">
          <el-row>
            <el-form-item :label="$t('components_device_detail_date_datePicker.ji_lu_shi_jian')" prop="timer" :rules="rules.timer">
              <custom-date-picker
                style="width: 100%"
                v-model="form.timer"
                type="datetimerange"
                value-format="YYYY-MM-DD HH:mm:ss"
                :picker-options="pickerOptionsIntervalMonth"
                :init-value="initValue"
              ></custom-date-picker>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="saveContact">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: ['value'],
  data() {
    return {
      visible: false,
      form: { timer: [] },
      initValue: [],
    };
  },
  computed: {
    rules() {
      return {
        timer: [{ required: true, message: this.$t('components_device_detail_date_datePicker.qxzjlsj') }],
      };
    },
  },
  mounted() {
    this.initValue = [moment().subtract('month', 1).format('YYYY-MM-DD 00:00:00'), moment().format('YYYY-MM-DD 23:59:59')];
    this.initDialog();
    if (this.$refs.form) {
      this.$refs.form.resetFields();
    }
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // 确认保存分组
    saveContact: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$emit('input', this.form.timer);
        this.$emit('success');
        this.closeDialog();
      });
    },
  },
};
</script>

<style lang="scss">
.device-date-event-datePicker {
  .tip {
    background: #fef4db;
    margin-bottom: 10px;
    padding-left: 10px;
    margin-right: 8px;
    .icon {
      color: #eebf4d;
      font-size: 12px;
      margin-right: 10px;
    }
    span {
      line-height: 32px;
      color: #6c757d;
      font-size: 12px;
    }
  }
}
</style>
